<div [id]="panelId" class="toolbarBase editable hover">
	<div class="toolbar" [id]="toolbarId"></div>
	<div #editordiv [id]="editorId" class="stages_description" contenteditable="true"></div>
	<ng-container *ngIf="isTextCreatorConfigured && (isEditorAvailable$ | async)">
		<stages-ai-floating-menu
			[selectedText]="(selectedHtml$ | async)!"
			[prompts]="prompts"
			[beanType]="beanType"
			(updatedText$)="updateEditorContent($event)"
		></stages-ai-floating-menu>
	</ng-container>
</div>

<div *ngIf="isTextCreatorConfigured && prompts.length > 0" class="info">
	<stages-disclaimer-main [hideALittle]="true" [message]="'ai.widget.legal'"></stages-disclaimer-main>
</div>
